import React, {PureComponent} from 'react';
import {casinoGamesStore} from 'app/store/global';

interface FirstLevelItemProps {
    className?: string
    name: string
    value?: string
    onClick?: () => void
}

export default class FirstLevelItem extends PureComponent<FirstLevelItemProps> {
    changeSortActive = (): void => {
        const {value, onClick} = this.props;

        casinoGamesStore.changeSelectSorting(value);
        onClick?.();
    };

    render(): React.ReactNode {
        const {className, name} = this.props;
        return <button
            onClick={this.changeSortActive}
            className={className}>
            {name}
        </button>;
    }
}
